export const Footer = () => {
    return (
        <footer>
            <p>© 2025 Solaris Energy. All Rights Reserved.</p>
            <small>Designed with ☀️ by ChatGPT</small>
        </footer>
    )
}